import { render } from "./LeadsPerPlatform.vue?vue&type=template&id=050bf538&scoped=true"
import script from "./LeadsPerPlatform.vue?vue&type=script&lang=js"
export * from "./LeadsPerPlatform.vue?vue&type=script&lang=js"

import "./LeadsPerPlatform.vue?vue&type=style&index=0&id=050bf538&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050bf538"]])

export default __exports__